import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { LoisirsAtna } from '../components/loisirs/LoisirsAtna';
import { ReadinessCard } from '../components/loisirs/ReadinessCard';
import { ForYou } from '../components/loisirs/ForYou';
import { MyActivities } from '../components/loisirs/MyActivities';
import { CardAccess } from '../components/loisirs/CardAccess';
import { BookingServices } from '../components/loisirs/BookingServices';
import { RegistrationFlow } from '../components/loisirs/RegistrationFlow';
import type { Activity } from '../data/loisirs';
export function MesLoisirs() {
  const [registering, setRegistering] = useState<Activity | null>(null);
  return <main className="bg-white" data-id="element-2979" data-mp="1fz8pl4638513">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2980" data-mp="1fy7cyv9fbah9">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2981" data-mp="2cjhgjkz7ay2v">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2982" data-mp="27pwo08gdmwb2">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2983" data-mp="2b270llj61iiw" />
          <span aria-current="page" data-id="element-2984" data-mp="2fye2n38fy9vk">Mes loisirs</span>
        </nav>

        <header className="mt-4" data-id="element-2985" data-mp="21at13dr7sipr">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2986" data-mp="219rhgkw4unwf">Mes loisirs</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2987" data-mp="2671ccg2ajrrn">
            Découvrez, réservez et accédez aux activités de la Ville, simplement.
          </p>
        </header>

        <div className="mt-8" data-id="element-2988" data-mp="1xa0teoxzqlvl">
          <LoisirsAtna onChip={() => undefined} data-id="element-2989" data-mp="1x63b25j8lycr" />
        </div>

        <div className="mt-8" data-id="element-2990" data-mp="1icqaiuj0qdpu">
          <ReadinessCard data-id="element-2991" data-mp="1idjk039d3hbo" />
        </div>

        <ForYou onRegister={setRegistering} data-id="element-2992" data-mp="1n9grdk2nddcb" />
        <MyActivities data-id="element-2993" data-mp="1nccoj66o7xzp" />
        <CardAccess data-id="element-2994" data-mp="3cpg2v7tqnev4" />
        <BookingServices data-id="element-2995" data-mp="3coyc2qpuhsul" />
      </div>

      <RegistrationFlow activity={registering} onClose={() => setRegistering(null)} data-id="element-2996" data-mp="3cpzksoje2395" />
    </main>;
}